<div class="commission-redirection-details-view-container" *ngIf="commissionRedirectionObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutAlign="space-between center" >
    <div fxLayout="row" fxLayoutGap="15px">
      <button
        [disabled]="!(userPermissions | async).commission_redirection.write"
        (click)="modify()"
        mat-stroked-button color="primary"
      ><mat-icon>create</mat-icon> <span> Edytuj</span></button>
      <button
        [disabled]="!(userPermissions | async).commission_redirection.delete"
        (click)="modifyRatePaid()"
        mat-stroked-button color="primary"
      ><mat-icon>create</mat-icon> <span> Zmień stawkę</span></button>
      <button
        [disabled]="!(userPermissions | async).commission_redirection.delete"
        (click)="delete()"
        mat-stroked-button color="warn"
      ><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    </div>
    <button *ngIf="commissionRedirectionObject.expect"
      [disabled]="true"
      mat-stroked-button color="primary"
    ><span> Oczekuje</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane polisy</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="TU" [value]="commissionRedirectionObject.insuranceCompany?.name"
                          [link]="['/tu/szczegoly', commissionRedirectionObject.insuranceCompany?.id]"></app-detail>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Firma" [value]="commissionRedirectionObject.company?.name"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="commissionRedirectionObject.ofwca?.fullName"
                          [link]="commissionRedirectionObject.ofwca ? ['/ofwca/szczegoly', commissionRedirectionObject.ofwca.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Zewnętrzna OFWCA (np. z TU)" [value]="!commissionRedirectionObject.ofwca"></app-detail-bool>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Numer polisy">
                  <span class="extra-letter-spacing">{{commissionRedirectionObject.policyNumber}}</span>
                </app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Nazwa klienta" [value]="">
                  <span class="extra-letter-spacing">{{commissionRedirectionObject.customerName}}</span>
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool fxFlex="100" header="Brak numeru polisy" [value]="!commissionRedirectionObject.policyNumber"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool fxFlex="100" header="Proporcjonalna prowizja" [value]="commissionRedirectionObject.proportionalCommission"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="25" header="Data zawarcia" [value]="commissionRedirectionObject.concludeDate | date:'y-MM-dd'"></app-detail>
              <app-detail fxFlex="25" header="Przypis"> {{(commissionRedirectionObject.assign === null ? 0 : commissionRedirectionObject.assign) | number:'1.2-2'}} zł
              </app-detail>
              <app-detail fxFlex="25" header="Stawka % Partner" *ngIf="(userPermissions | async).commission_redirection.delete">
                <mat-chip-list *ngIf="commissionRedirectionObject.ratePaid" [disabled]="!(userPermissions | async).commission_redirection.delete" >
                  <mat-chip class="green-mat-chip" selected >{{commissionRedirectionObject.ratePaid}}</mat-chip>
                </mat-chip-list>
              </app-detail>
              <app-detail fxFlex="25" header="Ryzyko ASF" *ngIf="(userPermissions | async).commission_redirection.delete" [value]="commissionRedirectionObject?.risk?.name"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uzupełnianie numeru polisy oraz nazwy klienta</h3>
            </div>

            <div fxLayout="column">
              <p>
                Znak &quot;%&quot; reprezentuje zero, jeden lub wiele dowonlnych znaków. Znak &quot;_&quot; reprezentuje dokładnie jeden dowolny znak.
              </p>
              <h4 class="small-margin-header">Przepinanie polisy wraz ze wznowieniami:</h4>
              <ul>
                <li>Link 4: zamiast ostatniego znaku (nr wznowienia) znak "_", np. zamiast K1234567890 wpisujemy K123456789_</li>
                <li>PZU: zamiast pełnego numeru polisy podajemy znaki do "-", np. zamiast 123456789-1 wpisujemy 123456789%</li>
                <li>InterRisk: zamiast pełnego numeru polisy podajemy znaki do "-", np. zamiast KM-H/P0123456-A wpisujemy KM-H/P0123456%</li>
              </ul>
            </div>

            <div fxLayout="column">
              <h4 class="small-margin-header">Zasady przepinania polis:</h4>
              <ul>
                <li>
                  Jeśli dla prowizji zostanie utworzone wiele przepięć, to przypisujemy zgodnie z najnowszym przepięciem.
                </li>
                <li>
                  Jeśli polisa została wystawiona przez OFWCA ASF, to wymagane jest poprawne wskazanie OFWCA z bazy systemu.
                </li>
                <li>
                  Jeśli polisa została wystawiona przez OFWCA nieistniejącą w bazie systemu, to wymagane jest zaznaczenie pola "Zewnętrzna OFWCA (np. z TU)".
                </li>
                <li>
                  Zamiast "ASF Premium sp. z o.o." jako nazwę klienta podajemy "ASF Premium%". Dzięki temu rekord prowizji, dla którego nazwa klienta to np. "ASF Premium spółka z o.o." także zostanie przepięty.
                </li>
              </ul>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Na kogo przepinamy</h3>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Prowizja ASF" [value]="!commissionRedirectionObject.newOfwca"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="commissionRedirectionObject.newOfwca?.fullName"
                          [link]="commissionRedirectionObject.newOfwca ? ['/ofwca/szczegoly', commissionRedirectionObject.newOfwca?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-detail header="Umowa"
                            [value]="commissionRedirectionObject.newContract ? (commissionRedirectionObject.newContract?.type.name + ' (nr: ' + commissionRedirectionObject.newContract?.number + '), zawarta ' + (commissionRedirectionObject.newContract?.concludeDate | date:'y-MM-dd')) : ''"
                            [link]="commissionRedirectionObject.newContract ? ['/umowy/szczegoly', commissionRedirectionObject.newContract.uuid] : undefined">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Partner" [value]="commissionRedirectionObject.newPartner?.shortName"
                          [link]="commissionRedirectionObject.newPartner ? ['/partnerzy/szczegoly', commissionRedirectionObject.newPartner?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="	Regionalny (majątek) Partnera"
                          [value]="commissionRedirectionObject.newPartner?.assetsRegional?.fullName"
                          ></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
